// export let BASE_URL = {url: 'https://api.ingame-server.ru'};

// export let BASE_URL = {url: 'http://localhost:3000'};
export let BASE_URL = {url: '/api'};
// export let BASE_URL = {url: 'http://192.168.1.4:3000'};
// export let BASE_URL = {url: 'http://135.106.158.19:3000'};

/**
 * Origin для socket.io (табло). Не путать с BASE_URL='/api':
 * io('/api') = namespace на хосте SPA, а не бэкенд.
 * Пусто → из absolute BASE_URL, иначе window.location (и :8080→:3000 на proto).
 * Явно: export let SOCKET_URL = 'http://135.106.158.19:3000';
 */
export let SOCKET_URL = '';











const imageFileName = (image) => String(image || '').split('/').pop();

const isInlineImage = (image) => {
  const value = String(image || '');
  return value.startsWith('data:') || value.startsWith('blob:');
};

/**
 * Static media is served under the same BASE_URL as the API, e.g.:
 *   BASE_URL=/api → /api/images/players/123.jpg
 *   BASE_URL=http://host:3000 → http://host:3000/images/players/123.jpg
 */
const getStaticFilesBase = () => String(BASE_URL.url || '').replace(/\/+$/, '');

const joinWithBaseUrl = (imagePath) => {
  let path = String(imagePath || '');
  if (!path) return '';
  if (!path.startsWith('/')) path = `/${path}`;

  const base = getStaticFilesBase();
  if (!base) return path;

  // Already absolute under /api/... — don't turn into /api/api/...
  if (base === '/api' && path.startsWith('/api/')) return path;
  if (path.startsWith(`${base}/`) || path === base) return path;

  // Path already has /api/... while base is http://host/api
  if (path.startsWith('/api/') && base.endsWith('/api')) {
    return `${base.slice(0, -4)}${path}`;
  }

  return `${base}${path}`;
};

const isLocalHostname = (hostname) => {
  const host = String(hostname || '').replace(/^\[|\]$/g, '').toLowerCase();
  if (!host) return false;
  if (host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0' || host === '::1') return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  if (/^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  return false;
};

/**
 * Underlozhki are served from /images/socials_patterns/, not /resources/afl_social/images/.
 * Sponsor files stay under .../images/sponsors/.
 */
const remapSocialUnderlozhkaPath = (value) => String(value || '').replace(
  /\/?resources\/afl_social\/images\/(?!sponsors\/)/gi,
  '/images/socials_patterns/'
);

/**
 * API sometimes returns absolute dev URLs (http://localhost:3000/resources/...).
 * Keep public http(s) links, rewrite local origins onto BASE_URL,
 * and point underlozhka files at /images/socials_patterns/.
 */
export const rewriteLocalMediaUrl = (value) => {
  const raw = remapSocialUnderlozhkaPath(String(value || '').trim());
  if (!raw) return '';
  if (raw.startsWith('data:') || raw.startsWith('blob:')) return raw;

  if (/^(https?:)?\/\//i.test(raw)) {
    try {
      const url = raw.startsWith('//') ? new URL(`http:${raw}`) : new URL(raw);
      if (!isLocalHostname(url.hostname)) return raw;
      return joinWithBaseUrl(`${url.pathname}${url.search}${url.hash}`);
    } catch (error) {
      return raw;
    }
  }

  return joinWithBaseUrl(raw);
};

const LOCAL_ORIGIN_IN_TEXT_RE = /(?:https?:)?\/\/(?:localhost|127\.0\.0\.1|0\.0\.0\.0|\[::1\]|10(?:\.\d{1,3}){3}|192\.168(?:\.\d{1,3}){2}|172\.(?:1[6-9]|2\d|3[01])(?:\.\d{1,3}){2})(?::\d+)?(?![.\w-])/gi;

/** Rewrite localhost origins and old underlozhka paths inside HTML or other text. */
export const rewriteLocalMediaInText = (value) => {
  const text = remapSocialUnderlozhkaPath(String(value ?? ''));
  if (!text) return text;
  const base = getStaticFilesBase();
  return text.replace(LOCAL_ORIGIN_IN_TEXT_RE, base);
};

/** Resolve a backend media path (/images/...) against BASE_URL. */
export const resolveMediaUrl = (imagePath) => rewriteLocalMediaUrl(imagePath);

export const getTeamImageUrl = (image) => {
  if (!image) {
    return '';
  }
  if (isInlineImage(image)) {
    return String(image);
  }
  let path = String(image);
  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      path = url.pathname + url.search;
    } catch (error) {
      path = '/' + imageFileName(path);
    }
  }
  const file = imageFileName(path);
  if (!file || file === 'defaultLogo.png') {
    return '';
  }
  // Prefer API path from backend; fall back to /images/teams/{file}
  if (!path.includes('/')) {
    path = `/images/teams/${file}`;
  } else if (path.includes('/api/img/logos/')) {
    path = `/images/teams/${file}`;
  }
  return joinWithBaseUrl(path);
};

export const getPlayerImageUrl = (image) => {
  if (!image) {
    return '';
  }
  if (isInlineImage(image)) {
    return String(image);
  }
  let path = String(image);
  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      path = url.pathname + url.search;
    } catch (error) {
      path = '/' + imageFileName(path);
    }
  }
  const file = imageFileName(path);
  if (!file || file === 'defaultAvatar.png' || file === 'defaultLogo.png') {
    return '';
  }
  // Prefer API path from backend; fall back to /images/players/{file}
  if (!path.includes('/')) {
    path = `/images/players/${file}`;
  } else if (path.includes('/api/img/players/')) {
    path = `/images/players/${file}`;
  }
  return joinWithBaseUrl(path);
};

export const getStadiumImageUrl = (image) => {
  if (!image) {
    return '';
  }
  if (isInlineImage(image)) {
    return String(image);
  }
  let path = String(image);
  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      path = url.pathname + url.search;
    } catch (error) {
      path = '/' + imageFileName(path);
    }
  }
  const file = imageFileName(path);
  if (!file || file === 'defaultAvatar.png' || file === 'defaultLogo.png' || file === 'defaultStadium.png') {
    return '';
  }
  if (!path.includes('/')) {
    path = `/images/stadiums/${file}`;
  } else if (path.includes('/api/img/stadiums/')) {
    path = `/images/stadiums/${file}`;
  } else if (path.includes('/api/img/leagues/')) {
    path = `/images/leagues/${file}`;
  }
  return joinWithBaseUrl(path);
};

export const getChampionshipImageUrl = (image) => getStadiumImageUrl(image);
export const getTournamentImageUrl = (image) => getStadiumImageUrl(image);
export const getNewsImageUrl = (image) => getStadiumImageUrl(image);

export const getUserImageUrl = (image) => {
  if (!image) {
    return '';
  }
  if (isInlineImage(image)) {
    return String(image);
  }
  let path = String(image);
  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      path = url.pathname + url.search;
    } catch (error) {
      path = '/' + imageFileName(path);
    }
  }
  const file = imageFileName(path);
  if (!file || file === 'defaultAvatar.png' || file === 'defaultLogo.png') {
    return '';
  }
  // Prefer API path from backend; fall back to /images/users/avatars/{file}
  if (!path.includes('/')) {
    path = `/images/users/avatars/${file}`;
  } else if (path.includes('/api/img/')) {
    path = `/images/users/avatars/${file}`;
  }
  return joinWithBaseUrl(path);
};

/** Resolve any admin media path through BASE_URL-aware helpers. */
export const getCdnImageUrl = (image, type) => {
  if (!image) return '';
  if (isInlineImage(image)) return String(image);
  const kind = String(type || '');
  if (kind === 'player') return getPlayerImageUrl(image);
  if (kind === 'team') return getTeamImageUrl(image);
  if (kind === 'user' || kind === 'staff') return getUserImageUrl(image);
  if (kind === 'stadium') return getStadiumImageUrl(image);
  if (kind === 'league' || kind === 'tournament' || kind === 'news' || kind === 'championship') {
    return getTournamentImageUrl(image);
  }
  const value = String(image);
  if (value.includes('/players/')) return getPlayerImageUrl(value);
  if (value.includes('/logos/') || value.includes('/teams/')) return getTeamImageUrl(value);
  if (value.includes('/users/') || value.includes('/avatars/')) return getUserImageUrl(value);
  if (value.includes('/stadiums/') || value.includes('/leagues/') || value.includes('/news/')) {
    return getStadiumImageUrl(value);
  }
  return getStadiumImageUrl(value);
};



export const API_URLS = {
  getAllMatches: '/matches/all',
  getMatch: '/matches/',
  getAdminMatches: '/matches/getAdminMatches',
  getAdminLeagueMatches: '/matches/getAdminLeagueMatches',
  checkMatchExists: '/matches/checkMatchExists',
  setMatch: '/matches/setMatch',
  getAdminMatch: '/matches/getAdminMatch',
  getRosterEvents: '/matches/getRosterEvents',
  setAllResults: '/matches/setAllResults',
  setAdminMatchRosterEvents: '/matches/setAdminMatchRosterEvents',
  setAdminMatchApplication: '/matches/setAdminMatchApplication',
  setAdminMatchLineup: '/matches/setAdminMatchLineup',
  getAdminMatchLineup: '/matches/getAdminMatchLineup',
  setMatchData: '/matches/setMatchData',
  setMatchExtraData: '/matches/setMatchExtraData',
  changeAdminMatchState: '/matches/changeAdminMatchState',
  setAdminMatchPenalties: '/matches/setAdminMatchPenalties',
  deleteAdminMatchPenalties: '/matches/deleteAdminMatchPenalties',
  setAdminMatchPlayState: '/matches/setAdminMatchPlayState',
  setAdminMatchScore: '/matches/setAdminMatchScore',

  getTabloStyles: '/tablo/getTabloStyles',
  setTabloSession: '/tablo/setTabloSession',
  setTabloLeagueStyle: '/tablo/setTabloLeagueStyle',
  getTabloState: '/tablo/getTabloState',
  getTabloLayers: '/tablo/getTabloLayers',
  getTabloOverlay: '/tablo/getOverlay',
  tabloOverlay: '/tablo/overlay',
  closeTabloSession: '/tablo/closeTabloSession',
  deleteTabloSession: '/tablo/deleteTabloSession',
  rotateTabloOverlayKey: '/tablo/rotateTabloOverlayKey',
  setMatchBestPlayer: '/matches/setBestPlayer',
  unsetMatchBestPlayer: '/matches/unsetBestPlayer',
  setAdminMatchStatistics: '/matches/setAdminMatchStatistics',
  changeAdminMatch: '/matches/changeAdminMatch',
  updateManyMatches: '/matches/updateMany',
  setAdminMatchClock: '/matches/setAdminMatchClock',
  setAdminStaffMatch: '/matches/setAdminStaffMatch',
  setAdminMatchPhotoSet: '/matches/setAdminMatchPhotoSet',
  deleteAdminMatchPhotoSet: '/matches/deleteAdminMatchPhotoSet',
  addAdminMatchVideo: '/matches/addAdminMatchVideo',
  changeAdminMatchVideo: '/matches/changeAdminMatchVideo',
  deleteAdminMatchVideo: '/matches/deleteAdminMatchVideo',
  addAdminMatchEvent: '/matches/addAdminMatchEvent',
  addAdminMatchEvents: '/matches/addAdminMatchEvents',
  changeMatchEvent: '/matches/changeEvent',
  removeMatchEvent: '/matches/removeEvent',
  deleteMatch: '/matches/deleteMatch',
  getAdminStaff: '/matches/getAdminStaff',
  getAdminStaffMatches: '/matches/getAdminStaffMatches',
  setAdminStaffMatches: '/matches/setAdminStaffMatches',
  setMatchPhotoes: '/matches/setMatchPhotoes',

  login: '/users/login/admin',
  logout: '/users/logout',
  refreshTokens: '/users/refreshTokens',
  adminAuthCheck: '/users/adminAuthCheck',
  adminAuthTelegramSend: '/users/adminAuthTelegramSend',
  adminAuthTelegramVerify: '/users/adminAuthTelegramVerify',
  adminAuthSmsSend: '/users/adminAuthSmsSend',
  adminAuthSmsVerify: '/users/adminAuthSmsVerify',
  adminAuthComplete: '/users/adminAuthComplete',
  emailSendCode: '/users/emailSendCode',
  adminAuthForgot: '/users/adminAuthForgot',
  adminAuthForgotSms: '/users/adminAuthForgotSms',
  adminAuthForgotVerify: '/users/adminAuthForgotVerify',
  adminAuthForgotReset: '/users/adminAuthForgotReset',
  adminAuthMergeDuplicate: '/users/adminAuthMergeDuplicate',
  adminAuthChangePassword: '/users/adminAuthChangePassword',
  editAdminAccount: '/users/editAdminAccount',
  getAdminUsers: '/users/getAdminUsers',
  getAdminUser: '/users/getAdminUser',
  changeAdminUser: '/users/changeAdminUser',
  addAdminUser: '/users/addAdminUser',
  linkAdminUserPlayer: '/users/linkAdminUserPlayer',
  unlinkAdminUserPlayer: '/users/unlinkAdminUserPlayer',

  getMatchActiveApplication: '/matches/getRosterEvents',

  getAllStadiums: '/stadiums/getAllStadiums',
  getAllAdminStadiums: '/stadiums/getAllAdminStadiums',
  changeStadiumsPriority: '/stadiums/changePriority',
  getAdminStadium: '/stadiums/getAdminStadium',
  getAdminPitch: '/stadiums/getAdminPitch',
  addPitch: '/stadiums/addPitch',
  changePitch: '/stadiums/changePitch',
  deletePitch: '/stadiums/deletePitch',
  changePitchesPriority: '/stadiums/changePitchPriority',
  addStadium: '/stadiums/addStadium',
  changeStadium: '/stadiums/changeStadium',
  deleteStadium: '/stadiums/deleteStadium',

  addAdminScheme: '/scheduler/addAdminScheme',
  changeAdminScheme: '/scheduler/changeAdminScheme',
  deleteAdminScheme: '/scheduler/deleteAdminScheme',
  getAdminSchemes: '/scheduler/getAdminSchemes',
  openAdminWishes: '/scheduler/openAdminWishes',
  deleteAdminWishes: '/scheduler/deleteAdminWishes',
  setAdminMatchSlots: '/scheduler/setAdminMatchSlots',

  getAdminCountries: '/tournaments/getAdminCountries',
  changeCountriesPriority: '/tournaments/changeCountriesPriority',
  getAdminCountry: '/tournaments/getAdminCountry',
  addCountry: '/tournaments/addCountry',
  changeCountry: '/tournaments/changeCountry',
  deleteCountry: '/tournaments/deleteCountry',
  changeLeaguesPriority: '/tournaments/changeLeaguesPriority',
  getAdminLeague: '/tournaments/getAdminLeague',
  getAdminLeagueRules: '/tournaments/getAdminLeagueRules',
  changeAdminLeagueRules: '/tournaments/changeAdminLeagueRules',
  addLeague: '/tournaments/addLeague',
  changeLeague: '/tournaments/changeLeague',
  deleteLeague: '/tournaments/deleteLeague',
  addCurator: '/tournaments/addCurator',
  changeCurator: '/tournaments/changeCurator',
  deleteCurator: '/tournaments/deleteCurator',
  changeSeasonsPriority: '/tournaments/changeSeasonsPriority',
  addSeason: '/tournaments/addSeason',
  changeSeason: '/tournaments/changeSeason',
  moveSeason: '/tournaments/moveSeason',
  getAdminSeason: '/tournaments/getAdminSeason',
  getTableTiebreakers: '/tournaments/getTableTiebreakers',
  getAdminApplications: '/tournaments/getAdminApplications',
  addApplication: '/tournaments/addApplication',
  changeApplication: '/tournaments/changeApplication',
  changeApplicationsPriority: '/tournaments/changeApplicationsPriority',
  addStage: '/tournaments/addStage',
  changeStage: '/tournaments/changeStage',
  deleteStage: '/tournaments/deleteStage',
  changeStagesPriority: '/tournaments/changeStagesPriority',
  getAdminSeasonTeams: '/tournaments/getAdminSeasonTeams',
  setSeasonTeams: '/tournaments/setSeasonTeams',
  addTeamLeague: '/tournaments/addTeamLeague',
  deleteTeamLeague: '/tournaments/deleteTeamLeague',
  getAdminSeasonGroups: '/tournaments/getAdminSeasonGroups',
  setSeasonGroups: '/tournaments/setSeasonGroups',
  getAdminSeasonActions: '/tournaments/getAdminSeasonActions',
  addTeamReplacement: '/tournaments/addTeamReplacement',
  deleteTeamReplacement: '/tournaments/deleteTeamReplacement',
  addTeamPenalty: '/tournaments/addTeamPenalty',
  deleteTeamPenalty: '/tournaments/deleteTeamPenalty',
  getCatalogTeams: '/tournaments/getAdminTeams',
  getCatalogTeam: '/tournaments/getAdminTeam',
  addCatalogTeam: '/tournaments/addTeam',
  changeCatalogTeam: '/tournaments/changeTeam',
  setAdminTeamDouble: '/tournaments/setAdminTeamDouble',
  deleteAdminTeamDouble: '/tournaments/deleteAdminTeamDouble',
  deleteCatalogTeam: '/tournaments/deleteTeam',
  getAdminTeamApplications: '/tournaments/getAdminTeamApplications',
  addCoach: '/tournaments/addCoach',
  changeCoach: '/tournaments/changeCoach',
  deleteCoach: '/tournaments/deleteCoach',
  getAdminPlayer: '/tournaments/getAdminPlayer',
  getAdminPlayers: '/tournaments/getAdminPlayers',
  addPlayer: '/tournaments/addPlayer',
  changePlayer: '/tournaments/changePlayer',
  changePlayerApplication: '/tournaments/changePlayerApplication',
  linkPlayerProfiles: '/tournaments/linkPlayerProfiles',
  unlinkPlayerProfiles: '/tournaments/unlinkPlayerProfiles',
  getAdminDuplicatePlayers: '/tournaments/getAdminDuplicatePlayers',
  mergeAdminDuplicatePlayers: '/tournaments/mergeAdminDuplicatePlayers',
  addPlayerCaptain: '/tournaments/addPlayerCaptain',
  deletePlayerCaptain: '/tournaments/deletePlayerCaptain',
  getAdminCapApplications: '/tournaments/getAdminCapApplications',
  getAdminCapApplication: '/tournaments/getAdminCapApplication',
  getAdminPendingCapApplicationsCount: '/tournaments/getAdminPendingCapApplicationsCount',
  getAdminPlayerApplications: '/tournaments/getAdminPlayerApplications',
  acceptCapApplication: '/tournaments/acceptCapApplication',
  declineCapApplication: '/tournaments/declineCapApplication',

  getAllReferees: '/judges/getAllReferees',

  getAllAdminLeagues: '/leagues/allAdminLeagues',
  
  getAllClients: '/championships/allClients',
  getChampionshipsGroupedByCity: '/championships/groupedByCity',
  setDefaultChamp: '/users/setDefaultChamp',
  getAdminBadges: '/users/getAdminBadges',

  getRoster: '/teams/:teamId/applications',

  getAdminTeams: '/teams/getAdminTeams',
  getAdminTeam: '/teams/getAdminTeam',
  addTeam: '/teams/addTeam',
  connectToLeague: '/teams/connectToLeague',
  
  getAdminClients: '/clients/getAdminClients',
  getAdminChampionships: '/championships/getAdminChampionships',
  getAdminLeagues: '/leagues/getAdminLeagues',
  getLeagueSeasons: '/leagues',  // Will add /:leagueId/adminLeagues dynamically
  
  getAvailableTeamApplications: '/teams/adminAvailableApplications',
  getTeamApplication: '/teams/getTeamApplicationQuery',
  getPlayerApplications:'/players/:playerId/adminApplicationsWithLeagues',
  declineApplication: '/teams/declineTeamApplication',
  acceptApplication: '/teams/acceptTeamApplication',

  searchPlayersByParams: '/players/search',

  getBlackList: '/tournaments/getAdminBlackList',
  getAdminBlackList: '/tournaments/getAdminBlackList',
  getAdminBlackListPlayer: '/tournaments/getAdminBlackListPlayer',
  addAdminBlackList: '/tournaments/addAdminBlackList',
  changeAdminBlackList: '/tournaments/changeAdminBlackList',
  deleteAdminBlackList: '/tournaments/deleteAdminBlackList',

  getAdminDisqualifications: '/leagues/getAdminDisqualifications',
  getAdminDisqualification: '/leagues/getAdminDisqualification',
  addAdminDisqualification: '/leagues/addAdminDisqualification',
  removeAdminDisqualification: '/leagues/removeAdminDisqualification',
  getAdminDisqualificationSettings: '/leagues/getAdminDisqualificationSettings',
  changeAdminDisqualificationSettings: '/leagues/changeAdminDisqualificationSettings',
  removeAdminDisqualificationSettings: '/leagues/removeAdminDisqualificationSettings',
  getAdminDisqualificationLeagues: '/leagues/getAdminDisqualificationLeagues',
  getAdminTransferWindows: '/leagues/getAdminTransferWindows',
  getAdminTransferWindow: '/leagues/getAdminTransferWindow',
  changeAdminTransferWindow: '/leagues/changeAdminTransferWindow',
  removeAdminTransferWindow: '/leagues/removeAdminTransferWindow',
  getAdminSeasonTransferWindows: '/leagues/getAdminSeasonTransferWindows',
  changeAdminSeasonTransferWindow: '/leagues/changeAdminSeasonTransferWindow',
  getLeaguePlayers: '/players/get_league_players',

  getAdminNewsList: '/league_news/getAdminNewsList',
  getAdminNewsTags: '/league_news/getAdminNewsTags',
  getAdminNewsItem: '/league_news/getAdminNewsItem',
  addAdminNews: '/league_news/addAdminNews',
  changeAdminNews: '/league_news/changeAdminNews',
  deleteAdminNews: '/league_news/deleteAdminNews',
  getAdminSearch: '/search/getAdminSearch',

  getAdminReportSummary: '/reports/getAdminReportSummary',
  getAdminReportMatches: '/reports/getAdminReportMatches',
  getAdminReportStaff: '/reports/getAdminReportStaff',
  getAdminReportPlayersCount: '/reports/getAdminReportPlayersCount',
  getAdminReportPlayersList: '/reports/getAdminReportPlayersList',
  getAdminReportBirthdays: '/reports/getAdminReportBirthdays',
  getAdminReportStats: '/reports/getAdminReportStats',

  getAdminClientForms: '/championships/getAdminClientForms',
  getAdminClientForm: '/championships/getAdminClientForm',
  setAdminClientFormStatus: '/championships/setAdminClientFormStatus',
  getAdminPendingClientFormsCount: '/championships/getAdminPendingClientFormsCount',

  socialTournamentTable: '/social_pictures/tournament_table',
  socialTop10: '/social_pictures/top10',
  socialCards: '/social_pictures/cards',
  socialDisqualifications: '/social_pictures/disqualifications',
  socialAfisha: '/social_pictures/afisha',
  socialSchedule: '/social_pictures/schedule',
  socialResults: '/social_pictures/results',
  socialChess: '/social_pictures/chess',
  socialGroupTables: '/social_pictures/group_tables',
  socialCalendar: '/social_pictures/calendar',
  socialPlayoff: '/social_pictures/playoff',
  socialPreview: '/social_pictures/preview',
  socialDetailedResult: '/social_pictures/detailed_result',
  socialAnnouncement: '/social_pictures/announcement',
  socialQuote: '/social_pictures/quote',
  socialAchievements: '/social_pictures/achievements',
  socialMatchCoverGoal: '/social_pictures/match_cover_goal',
  socialBroadcastPreview: '/social_pictures/broadcast_preview',
  socialTourTeam: '/social_pictures/tour_team_v2',
  socialMatchStats: '/social_pictures/match_stats_v2',
  socialMvp: '/social_pictures/mvp_v2',
  socialMatchSubs: '/social_pictures/match_subs_v2',
  socialMatchLineups: '/social_pictures/match_lineups_v2',
  socialV2Types: '/social_pictures/v2_types',
  socialTournamentTableUnderlozhki: '/social_pictures/tournament_table_v2_underlozhki',
  socialTournamentTableStyles: '/social_pictures/tournament_table_v2_styles',
  socialTournamentTableStylesSaveLeague: '/social_pictures/tournament_table_v2_styles/save_league',
  socialTournamentTableStylesSchemesList: '/social_pictures/tournament_table_v2_styles/schemes/list',
  socialTournamentTableStylesSchemesSave: '/social_pictures/tournament_table_v2_styles/schemes/save',
  socialTournamentTableStylesSchemesDelete: '/social_pictures/tournament_table_v2_styles/schemes/delete',
  socialSponsors: '/social_pictures/sponsors',
  socialSponsorsAdd: '/social_pictures/sponsors/add',
  socialSponsorsDelete: '/social_pictures/sponsors/delete',
  socialTournamentTableSponsors: '/social_pictures/tournament_table_v2_sponsors',
  socialTournamentTableSponsorsSaveLeague: '/social_pictures/tournament_table_v2_sponsors/save_league',
  socialTournamentTableSponsorsSchemesList: '/social_pictures/tournament_table_v2_sponsors/schemes/list',
  socialTournamentTableSponsorsSchemesSave: '/social_pictures/tournament_table_v2_sponsors/schemes/save',
  socialTournamentTableSponsorsSchemesDelete: '/social_pictures/tournament_table_v2_sponsors/schemes/delete',

  // Расписание
  saveSchedule: '/leagues/saveSchedule',
  getTeamsByGroups: '/leagues/:leagueId/teamsByGroups',

};

export const leftTextFirstSlide = 
'Подключайте свою футбольную любительскую лигу на платформу мобильного приложения inGame! ' +
'Перенесём всю историю ваших чемпионатов. Постоянная техническая поддержка.'

export const rightTextFirstSlide = 
'Скачивайте приложение и смотрите статистику и информацию о матчах своей лиги! Оставляйте свои комментарии, впечатления и пожелания, с помощью вас мы сможем стать еще лучше.'

export const DOCUMENTS = {
  privacy: 'https://ingame-sports.ru/docs/soglashenie_o_konfidentsialnosti.docx',
  terms: 'https://ingame-sports.ru/docs/Polzovatelskoe_soglashenie.docx',
  personalData: 'https://ingame-sports.ru/docs/Politika_obrabotki_personalnykh_dannykh.docx',
  agreement: 'https://ingame-sports.ru/docs/Soglasie_na_obrabotku_pd_s.docx',
  cookies: 'https://ingame-sports.ru/docs/Politika_ispolzovaniya_failov_cookies.docx'
}
